module.exports = __webpack_public_path__ + "static/presenting-7-a5a5aabddd233f4760a86687360f9444.jpg";